import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";

export class CommandDeleteContract {
  async run(contractId: number): Promise<Contract> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return ContractSerializer.fromJson(response);
  }
}
